/**
 * @file vue 全局过滤器
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import { decodeUnicode } from '@tencent/slug-function'

Vue.filter('igDecodeUnicode', decodeUnicode)

/**
 * 时间格式化
 * @param {Number|String} time - 时间戳或字符串
 * @param {String} format - 时间格式：'YYYY-MM-DD hh:mm:ss'（默认值）
 * @param {Boolean} simplify - 是否简化时间格式
 */
Vue.filter('mcFormatTime', function (time, format = 'YYYY-MM-DD hh:mm:ss', simplify) {
    if (typeof time == 'string') {
        time = time.replace(/-/g, '/')
    }
    let date = new Date(time)

    // #region 简化时间格式，最多 7 天
    if (simplify) {
        let result = ''
        let difference = Date.now() - date.getTime()
        if (difference < 60000) {
            result = '刚刚'
        } else if (difference < 3600000) {
            result = parseInt(difference / 60000) + ' 分钟前'
        } else if (difference < 86400000) {
            result = parseInt(difference / 3600000) + ' 小时前'
        } else if (difference < 604800000) {
            result = parseInt(difference / 86400000) + ' 天前'
        }
        if (result) {
            return result
        }
    }
    // #endregion

    const patterns = {
        'M+': date.getMonth() + 1,
        'D+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    if (/Y+/.test(format)) {
        format = format.replace(RegExp.lastMatch, (date.getFullYear() + '').slice(4 - RegExp.lastMatch.length))
    }
    for (let p in patterns) {
        if (new RegExp('(' + p + ')').test(format)) {
            format = format.replace(RegExp.lastMatch, RegExp.lastMatch.length == 1 ? patterns[p] : String(patterns[p]).padStart(2, '0'))
        }
    }
    return format
})

/**
 * 数字格式化
 * @param {Number} num - 待格式化的数字
 */
Vue.filter('mcFormatNumber', function (num) {
    if (typeof num == 'undefined') {
        return 0
    }
    
    let result = num.toString()
    if (num > 100000000) {
        result = (num / 100000000).toFixed(1) + '亿'
    } else if (num > 10000) {
        result = (num / 10000).toFixed(1) + '万'
    }
    return result
})

/**
 * 距离格式化
 * @param {Number} num - 待格式化的距离
 */
Vue.filter('mcFormatDistance', function(num) {
    if (typeof num == 'undefined') {
        return ''
    }
    let result = num.toString()
    if(num > 1000) {
        result = (num / 1000).toFixed(1) + 'km'
    } else {
        result = num + 'm'
    }

    return result
})

/**
 * 对 4 个字节字符进行解码（emoji 表情）
 * @param {String} str - 需要处理的字符串
 * @returns {String} 处理后的字符串，4 个字节字符将被换成
 */
Vue.filter('igDecodeUnicode', function (str) {
    return str.replace(/\[u:(\d+)\]/g, function ($1, $2) {
        return String.fromCodePoint($2)
    })
})